import React, { useCallback, useEffect, useMemo, useState } from 'react';
import axios from '../../../utils/axios';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

export const initialLicences = [
  {
    id: 1,
    software: 'Microsoft 365 Business Premium',
    vendor: 'Microsoft',
    category: 'Productivity',
    version: 'Business Premium',
    licenceType: 'Subscription',
    total: 150,
    used: 126,
    renewal: '2026-11-15',
    cost: 216000,
    status: 'Active',
    owner: 'IT Department',
    description: 'Microsoft productivity and collaboration suite.',
    licenceKey: 'MS-365-KEY-9912',
    purchaseDate: '2026-01-15',
    expiryDate: '2026-11-15',
    billingCycle: 'Annual',
    currency: 'INR',
    purchaseOrder: 'PO-2026-001',
    contractNumber: 'MS-365-2026',
    department: 'IT',
    supportContact: 'Microsoft Support',
    notes: 'Core enterprise productivity suite.',
  },
  {
    id: 2,
    software: 'Adobe Creative Cloud',
    vendor: 'Adobe',
    category: 'Design',
    version: 'Teams',
    licenceType: 'Subscription',
    total: 40,
    used: 37,
    renewal: '2026-10-28',
    cost: 288000,
    status: 'Expiring Soon',
    owner: 'Creative Team',
    description: 'Creative Cloud applications for design teams.',
    licenceKey: 'ADB-CC-ENT-2025',
    purchaseDate: '2025-10-28',
    expiryDate: '2026-10-28',
    billingCycle: 'Annual',
    currency: 'INR',
    purchaseOrder: 'PO-2025-018',
    contractNumber: 'ADOBE-CC-2025',
    department: 'Design',
    supportContact: 'Adobe Enterprise Support',
    notes: 'Renewal review needed before end of October.',
  },
  {
    id: 3,
    software: 'JetBrains All Products Pack',
    vendor: 'JetBrains',
    category: 'Development',
    version: 'Enterprise',
    licenceType: 'Subscription',
    total: 35,
    used: 29,
    renewal: '2027-01-20',
    cost: 315000,
    status: 'Active',
    owner: 'Engineering',
    description: 'Development tools and IDE licence package.',
    licenceKey: 'JB-ALL-PACK-8801',
    purchaseDate: '2026-01-20',
    expiryDate: '2027-01-20',
    billingCycle: 'Annual',
    currency: 'INR',
    purchaseOrder: 'PO-2026-023',
    contractNumber: 'JB-ENT-2026',
    department: 'Engineering',
    supportContact: 'JetBrains Support',
    notes: 'Engineering team dev licenses.',
  },
  {
    id: 4,
    software: 'AutoCAD',
    vendor: 'Autodesk',
    category: 'Engineering',
    version: '2026',
    licenceType: 'Subscription',
    total: 20,
    used: 18,
    renewal: '2026-12-08',
    cost: 252000,
    status: 'Active',
    owner: 'Engineering',
    description: 'Engineering design and drafting software.',
    licenceKey: 'ACAD-2026-7712',
    purchaseDate: '2025-12-08',
    expiryDate: '2026-12-08',
    billingCycle: 'Annual',
    currency: 'INR',
    purchaseOrder: 'PO-2025-041',
    contractNumber: 'AUTO-CAD-2025',
    department: 'Engineering',
    supportContact: 'Autodesk Support',
    notes: '',
  },
  {
    id: 5,
    software: 'Slack Business+',
    vendor: 'Slack / Salesforce',
    category: 'Communication',
    version: 'Business+',
    licenceType: 'Subscription',
    total: 200,
    used: 195,
    renewal: '2027-02-14',
    cost: 192000,
    status: 'Active',
    owner: 'IT Department',
    description: 'Corporate real-time communication platform.',
    licenceKey: 'SLK-BIZ-PLUS-104',
    purchaseDate: '2026-02-14',
    expiryDate: '2027-02-14',
    billingCycle: 'Annual',
    currency: 'INR',
    purchaseOrder: 'PO-2026-009',
    contractNumber: 'SLK-2026',
    department: 'All',
    supportContact: 'Slack Support',
    notes: 'Company-wide workspace.',
  },
  {
    id: 6,
    software: 'VMware vSphere Enterprise',
    vendor: 'Broadcom',
    category: 'Infrastructure',
    version: '8.0 Enterprise',
    licenceType: 'Perpetual',
    total: 80,
    used: 68,
    renewal: null,
    cost: 480000,
    status: 'Active',
    owner: 'Infrastructure Team',
    description: 'Core virtualization platform for data center hosts.',
    licenceKey: 'VMW-VSPH-80-PERP',
    purchaseDate: '2024-05-10',
    expiryDate: null,
    billingCycle: 'One-time',
    currency: 'INR',
    purchaseOrder: 'PO-2024-012',
    contractNumber: 'VMW-ENT-2024',
    department: 'IT',
    supportContact: 'Broadcom Enterprise Support',
    notes: 'Under active maintenance contract.',
  },
  {
    id: 7,
    software: 'Figma Organization',
    vendor: 'Figma',
    category: 'Design',
    version: 'Org',
    licenceType: 'Subscription',
    total: 20,
    used: 19,
    renewal: '2026-10-30',
    cost: 112800,
    status: 'Expiring Soon',
    owner: 'Product Design',
    description: 'Collaborative interface design tool.',
    licenceKey: 'FIGMA-ORG-4412',
    purchaseDate: '2025-10-30',
    expiryDate: '2026-10-30',
    billingCycle: 'Annual',
    currency: 'INR',
    purchaseOrder: 'PO-2025-032',
    contractNumber: 'FIG-2025',
    department: 'Design',
    supportContact: 'Figma Support',
    notes: 'Needs 5 additional seats on renewal.',
  }
];

const emptyForm = {
  software: '',
  vendor: '',
  category: '',
  version: '',
  description: '',
  licenceType: 'Subscription',
  licenceKey: '',
  total: '',
  used: '0',
  renewal: '',
  purchaseDate: '',
  expiryDate: '',
  cost: '',
  billingCycle: 'Annual',
  currency: 'INR',
  purchaseOrder: '',
  contractNumber: '',
  owner: '',
  department: '',
  supportContact: '',
  status: 'Active',
  notes: '',
};

const SoftwareLicencesView = ({ licences: propLicences, setLicences: propSetLicences }) => {
  const [tab, setTab] = useState('all');
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('all');
  const [type, setType] = useState('all');

  const [internalLicences, setInternalLicences] = useState([]);
  const [loading, setLoading] = useState(propLicences === undefined);
  const [loadError, setLoadError] = useState('');
  const licences = propLicences !== undefined ? propLicences : internalLicences;
  const setLicences = propSetLicences !== undefined ? propSetLicences : setInternalLicences;

  const fetchLicences = useCallback(async () => {
    if (propLicences !== undefined) return;
    setLoading(true);
    try {
      const response = await axios.get('/software-licences');
      const body = response.data;
      const rows = Array.isArray(body) ? body : (Array.isArray(body?.data) ? body.data : []);
      setInternalLicences(rows.map((row) => ({
        id: row.id, software: row.software || '', vendor: row.vendor || '', category: row.category || '',
        version: row.version || '', description: row.description || '', licenceType: row.licence_type || 'Subscription',
        licenceKey: row.licence_key || '', total: Number(row.total || 0), used: Number(row.used || 0),
        renewal: row.renewal_date || null, purchaseDate: row.purchase_date || null, expiryDate: row.expiry_date || null,
        cost: Number(row.cost || 0), billingCycle: row.billing_cycle || 'Annual', currency: row.currency || 'INR',
        purchaseOrder: row.purchase_order || '', contractNumber: row.contract_number || '', owner: row.owner || '',
        department: row.department || '', supportContact: row.support_contact || '', status: row.status || 'Active', notes: row.notes || '',
      })));
      setLoadError('');
    } catch (error) {
      setLoadError(error.response?.data?.message || 'Unable to load software licences.');
    } finally {
      setLoading(false);
    }
  }, [propLicences]);

  useEffect(() => { fetchLicences(); }, [fetchLicences]);

  const [selectedLicence, setSelectedLicence] = useState(null);
  const [showDetailDrawer, setShowDetailDrawer] = useState(false);

  const filtered = useMemo(() => {
    return licences.filter((x) => {
      const q = search.toLowerCase();
      const searchOk =
        !q ||
        (x.software || '').toLowerCase().includes(q) ||
        (x.vendor || '').toLowerCase().includes(q) ||
        (x.category || '').toLowerCase().includes(q);

      const tabOk =
        tab === 'all' ||
        (tab === 'active' && x.status === 'Active') ||
        (tab === 'expiring' && x.status === 'Expiring Soon') ||
        (tab === 'perpetual' && x.licenceType === 'Perpetual');

      const statusOk = status === 'all' || x.status.toLowerCase() === status.toLowerCase();
      const typeOk = type === 'all' || x.licenceType.toLowerCase() === type.toLowerCase();

      return searchOk && tabOk && statusOk && typeOk;
    });
  }, [licences, search, tab, status, type]);

  const total = licences.reduce((s, x) => s + Number(x.total || 0), 0);
  const used = licences.reduce((s, x) => s + Number(x.used || 0), 0);
  const available = total - used;
  const spend = licences.reduce((s, x) => s + Number(x.cost || 0), 0);
  const expiring = licences.filter((x) => x.status === 'Expiring Soon').length;

  const money = (v) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(Number(v || 0));

  const date = (v) =>
    v
      ? new Date(`${v}T00:00:00`).toLocaleDateString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        })
      : 'Perpetual (No renewal)';

  const usage = (x) => (x.total ? Math.round((Number(x.used) / Number(x.total)) * 100) : 0);



  const handleViewLicence = (licence) => {
    setSelectedLicence(licence);
    setShowDetailDrawer(true);
  };

  return (
    <div className="space-y-6">
      {loadError && <div role="alert" className="rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-700">{loadError} <button type="button" className="underline ml-2" onClick={fetchLicences}>Retry</button></div>}
      {loading && <div className="text-sm text-muted-foreground">Loading software licences...</div>}
      {/* Stat Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-semibold uppercase text-muted-foreground">Total Licences</span>
            <span className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
              <Icon name="KeyRound" size={18} />
            </span>
          </div>
          <div className="text-2xl font-bold text-foreground">{total}</div>
          <div className="text-xs text-muted-foreground mt-1">Across {licences.length} software products</div>
        </div>

        <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-semibold uppercase text-muted-foreground">Licences in Use</span>
            <span className="w-8 h-8 rounded-lg bg-emerald-500/10 text-emerald-500 flex items-center justify-center">
              <Icon name="Users" size={18} />
            </span>
          </div>
          <div className="text-2xl font-bold text-foreground">{used}</div>
          <div className="text-xs text-muted-foreground mt-1">
            {total ? Math.round((used / total) * 100) : 0}% seat utilization
          </div>
        </div>

        <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-semibold uppercase text-muted-foreground">Available Seats</span>
            <span className="w-8 h-8 rounded-lg bg-blue-500/10 text-blue-500 flex items-center justify-center">
              <Icon name="PackageCheck" size={18} />
            </span>
          </div>
          <div className="text-2xl font-bold text-blue-500">{available}</div>
          <div className="text-xs text-muted-foreground mt-1">Ready for assignment</div>
        </div>

        <div className="bg-card border border-border rounded-xl p-4 shadow-sm">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-semibold uppercase text-muted-foreground">Annual Spend</span>
            <span className="w-8 h-8 rounded-lg bg-amber-500/10 text-amber-500 flex items-center justify-center">
              <Icon name="IndianRupee" size={18} />
            </span>
          </div>
          <div className="text-2xl font-bold text-amber-500">{money(spend)}</div>
          <div className="text-xs text-muted-foreground mt-1">{expiring} renewal alerts</div>
        </div>
      </div>

      {/* Upcoming Renewals Banner */}
      {expiring > 0 && (
        <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-amber-500/20 text-amber-500 flex items-center justify-center shrink-0">
              <Icon name="BellRing" size={18} />
            </div>
            <div>
              <h4 className="font-semibold text-foreground text-sm">Upcoming Software Renewals</h4>
              <p className="text-xs text-muted-foreground">
                {expiring} software licences require attention soon. Review seat utilization before renewing to avoid unused licence costs.
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            size="xs"
            onClick={() => setTab('expiring')}
          >
            Filter Expiring
          </Button>
        </div>
      )}

      {/* Filter and Action Bar */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 p-4 bg-card rounded-xl border border-border">
        <div className="flex flex-wrap items-center gap-2">
          {[
            ['all', 'All Licences'],
            ['active', 'Active'],
            ['expiring', 'Expiring Soon'],
            ['perpetual', 'Perpetual'],
          ].map(([id, label]) => (
            <button
              key={id}
              onClick={() => setTab(id)}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-smooth ${
                tab === id
                  ? 'bg-primary text-primary-foreground font-semibold shadow-sm'
                  : 'bg-muted text-muted-foreground hover:text-foreground'
              }`}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3 flex-wrap">
          <div className="relative min-w-[220px]">
            <input
              type="text"
              placeholder="Search software, vendor, category..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full bg-background border border-border rounded-lg pl-8 pr-3 py-1.5 text-xs text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary"
            />
            <Icon name="Search" size={14} className="absolute left-2.5 top-2.5 text-muted-foreground" />
          </div>

          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            className="px-2.5 py-1.5 bg-background border border-border rounded-lg text-xs text-foreground"
          >
            <option value="all">All Types</option>
            <option value="subscription">Subscription</option>
            <option value="perpetual">Perpetual</option>
          </select>
        </div>
      </div>

      {/* Software Table */}
      <div className="bg-card border border-border rounded-xl overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-muted/40 text-muted-foreground text-xs uppercase border-b border-border">
              <tr>
                <th className="py-3 px-4 font-semibold">Software Application</th>
                <th className="py-3 px-4 font-semibold">Type</th>
                <th className="py-3 px-4 font-semibold">Seat Utilization</th>
                <th className="py-3 px-4 font-semibold">Renewal Date</th>
                <th className="py-3 px-4 font-semibold">Annual Cost</th>
                <th className="py-3 px-4 font-semibold">Status</th>
                <th className="py-3 px-4 text-right font-semibold">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan={7} className="py-12 text-center text-muted-foreground">
                    <Icon name="SearchX" size={36} className="mx-auto mb-2 text-muted-foreground/60" />
                    <p className="font-medium">No software licences found matching your filters.</p>
                  </td>
                </tr>
              ) : (
                filtered.map((x) => {
                  const pct = usage(x);
                  return (
                    <tr key={x.id} className="hover:bg-muted/20 transition-colors">
                      <td className="py-3 px-4">
                        <div className="flex items-center gap-3">
                          <div className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center font-bold text-xs">
                            <Icon name="AppWindow" size={18} />
                          </div>
                          <div>
                            <div className="font-semibold text-foreground">{x.software}</div>
                            <div className="text-xs text-muted-foreground mt-0.5">
                              {x.vendor} • {x.category}
                            </div>
                          </div>
                        </div>
                      </td>

                      <td className="py-3 px-4 text-xs font-medium text-foreground">
                        {x.licenceType}
                      </td>

                      <td className="py-3 px-4 min-w-[180px]">
                        <div className="flex justify-between mb-1 text-xs">
                          <span className="font-medium">{x.used} / {x.total}</span>
                          <span className="text-muted-foreground">{pct}%</span>
                        </div>
                        <div className="h-1.5 bg-muted rounded-full overflow-hidden">
                          <div
                            className={`h-full rounded-full ${pct >= 90 ? 'bg-amber-500' : 'bg-primary'}`}
                            style={{ width: `${pct}%` }}
                          />
                        </div>
                        <div className="text-[10px] text-muted-foreground mt-0.5">
                          {Number(x.total) - Number(x.used)} available
                        </div>
                      </td>

                      <td className="py-3 px-4 text-xs">
                        <div className="flex items-center gap-1.5">
                          <Icon
                            name={x.status === 'Expiring Soon' ? 'AlertCircle' : 'CalendarDays'}
                            size={14}
                            className={x.status === 'Expiring Soon' ? 'text-amber-500' : 'text-muted-foreground'}
                          />
                          <span>{date(x.renewal)}</span>
                        </div>
                      </td>

                      <td className="py-3 px-4 text-xs font-semibold text-foreground">
                        {x.cost ? money(x.cost) : '—'}
                      </td>

                      <td className="py-3 px-4">
                        <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${
                          x.status === 'Expiring Soon'
                            ? 'bg-amber-500/10 text-amber-500 border border-amber-500/20'
                            : 'bg-emerald-500/10 text-emerald-500 border border-emerald-500/20'
                        }`}>
                          {x.status}
                        </span>
                      </td>

                      <td className="py-3 px-4 text-right">
                        <Button
                          variant="ghost"
                          size="xs"
                          onClick={() => handleViewLicence(x)}
                          iconName="Eye"
                        />
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>



      {/* Detail Drawer */}
      {showDetailDrawer && selectedLicence && (
        <div className="fixed inset-0 z-50 overflow-hidden bg-black/60 flex justify-end">
          <div className="w-full max-w-md bg-card h-full shadow-2xl flex flex-col border-l border-border animate-in slide-in-from-right duration-200">
            <div className="p-5 border-b border-border flex items-center justify-between bg-muted/20">
              <div>
                <h3 className="font-bold text-lg text-foreground">{selectedLicence.software}</h3>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {selectedLicence.vendor} • {selectedLicence.licenceType}
                </p>
              </div>
              <button
                onClick={() => setShowDetailDrawer(false)}
                className="w-8 h-8 rounded-lg flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted"
              >
                <Icon name="X" size={18} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-4 text-xs">
              <div className="p-3 bg-muted/30 rounded-lg space-y-2">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Licence Key:</span>
                  <span className="font-mono font-semibold text-foreground">{selectedLicence.licenceKey}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Seat Usage:</span>
                  <span className="font-semibold text-foreground">{selectedLicence.used} / {selectedLicence.total} ({usage(selectedLicence)}%)</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Annual Spend:</span>
                  <span className="font-semibold text-foreground">{money(selectedLicence.cost)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Next Renewal:</span>
                  <span className="font-semibold text-foreground">{date(selectedLicence.renewal)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">Department:</span>
                  <span className="font-semibold text-foreground">{selectedLicence.department || 'All'}</span>
                </div>
              </div>

              {selectedLicence.description && (
                <div>
                  <h4 className="font-semibold text-foreground mb-1">Description</h4>
                  <p className="text-muted-foreground">{selectedLicence.description}</p>
                </div>
              )}
            </div>

            <div className="p-4 border-t border-border flex justify-end">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setShowDetailDrawer(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SoftwareLicencesView;
